import { render, staticRenderFns } from "./DeletedTasks.vue?vue&type=template&id=0258120c&"
import script from "./DeletedTasks.vue?vue&type=script&lang=js&"
export * from "./DeletedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports